//@ts-nocheck
export default {
  MIN_VOLTAGE: 23.6,
  MAX_VOLTAGE: 28.0,
};
